import React from 'react';
import ImageListItem from './image-list-item';

//this component returns image tile list shown in desktop view
const ImageList = (props) => {
    const imageItems = props.images.map((image) => {
        return (
            <ImageListItem
                onImageSelect={props.onImageSelect}
                key={image.src150}
                image={image}
            />
        );
    });

    return (
        <div className='image-list'>
            {imageItems}
        </div>
    );

}

export default ImageList;


// WEBPACK FOOTER //
// ./src/components/image-list.js